import { Wrapper } from 'src/styles/user-mobile/OverviewStyleMobile';
import { BoardSetWidthStamp } from 'src/styles/user-mobile/StampStyle';

import styled from 'styled-components';
import { STAMP_GUIDE } from 'src/assets/database/stampData';
import { TopFixedBar } from 'src/styles/user-mobile/TopFixedBarStyle';

import x2 from 'src/assets/images/user-mobile/stamp/X2.svg';
import { useNavigate } from 'react-router-dom';

export default function StampGuideSingle() {
  const navigate = useNavigate();
  return (
    <Wrapper>
      <StyledTopFixedBar>
        <img onClick={() => navigate('/stamp')} src={x2} alt="" />
      </StyledTopFixedBar>
      <StyledBoardSetWidthStamp>
        <GuideImage src={STAMP_GUIDE} />
      </StyledBoardSetWidthStamp>
    </Wrapper>
  );
}

const StyledTopFixedBar = styled(TopFixedBar)`
  img {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    cursor: pointer;
  }
`;

const StyledBoardSetWidthStamp = styled(BoardSetWidthStamp)`
  background-image: none;
  background-color: var(--white, #fff);
  justify-content: center;
`;

const GuideImage = styled.img`
  width: 75%;
  height: auto;
  margin-bottom: 24px;
`;
